/* rails-erb-loader-dependencies config/initializers/constants.rb */
export const unitWeights = {"gram":1.0,"oz":28.35,"lb":453.592,"kg":1000.0};
export const costModeCookie = "recipal_cost_mode";
